<script>
  import { onMount } from 'svelte'
  import { createPostRequest } from '../src/create_request'
  import { focus } from '../src/utils'
  import { cart } from '../src/data_storage.js'
  cart.useLocalStorage()

  import { navigate } from "../rout"
  export let shop
  export let userId

  let password = ""
  let passwordInput
  let passwordConfirmation = ""
  let passwordConfirmationInput
  let activated = false
  let error = null

  function redirectToSignin() {
    setTimeout(navigate('/'+shop.slug+'/signin'), 1000);
  }

  function activate() {
    fetch(createPostRequest('/'+shop.slug+'/user/activate/'+userId+'.json',
                        'POST',
                        JSON.stringify({ user: { password: password, password_confirmation: passwordConfirmation }, slug: shop.slug})))
      .then(response => response.json())
      .then(data => {
        console.log('activate:')
        console.log(data)
        if (data.errors) {
          // alert(data.errors.email)
          console.log(data)
          error = data.errors
        } else if (data.activated) {
          activated = data.activated
          $cart[shop.id].activated = true
          $cart[shop.id].activationSent = false

          redirectToSignin()
        } else {
          error = "Something went wrong, try again later."
        }
      })
      .catch(err => {
        alert('error ' + err)
      })
  }

  onMount(async () => {
    console.log("signup onMount")

    activated = $cart[shop.id].activated || false
    if (activated) {
      $cart[shop.id].activationSent = false

      redirectToSignin()
    }
  })
</script>

<style>
</style>

<div class="frame mt-3">
  {#if activated}
    <div>Your account is now activated.</div>
  {:else}
    <h1>Activate your user account</h1>
    <form class="form" on:submit|preventDefault={activate}>
      <div>
        <label for="password">Password</label>
        <input id="user[password]" name="password" type="password" required bind:value={password} bind:this={passwordInput} use:focus/>
      </div>
      <div>
        <label for="password">Password Confirmation</label>
        <input id="user[password_confirmation]" name="password_confirmation" type="password" required bind:value={passwordConfirmation} bind:this={passwordConfirmationInput}/>
      </div>
      {#if error}
        <div class="mt-3 bg-red-100 flex flex-col items-center justify-center">
          {error}
        </div>
      {/if}
      <div>
        <button class="btn" type="submit">Activate</button>
      </div>
    </form>
  {/if}
</div>